import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import SEOHead from '../components/common/SEOHead';
import ContactForm from '../components/common/ContactForm';

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, ease: 'easeOut' }
};

const GetInTouchPage = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEOHead 
        title={t('meta.getInTouch.title')}
        description={t('meta.getInTouch.description')}
      />

      {/* Hero Section */}
      <section 
        className="relative pt-32 pb-16 bg-navy-deep"
        data-testid="get-in-touch-hero"
      >
        <div className="container-main">
          <div className="max-w-3xl">
            <motion.span 
              className="text-gold-main text-sm font-semibold uppercase tracking-widest block mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              {t('nav.getInTouch')}
            </motion.span>
            <motion.h1 
              className="font-alatsi text-5xl md:text-6xl text-white leading-tight mb-6"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              data-testid="get-in-touch-title"
            >
              {t('form.title')}
            </motion.h1>
            <motion.p 
              className="text-xl text-gray-300 leading-relaxed"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {t('form.subtitle')}
            </motion.p>
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section className="section-padding bg-white" data-testid="form-section">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <motion.div {...fadeUp}>
              <ContactForm />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Info Bar */}
      <section className="py-16 bg-slate-50" data-testid="info-bar">
        <div className="container-main">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-sm text-slate-500 uppercase tracking-wide mb-2">Response Time</p>
              <p className="font-alatsi text-xl text-navy-deep">Within 24 Hours</p>
            </div>
            <div>
              <p className="text-sm text-slate-500 uppercase tracking-wide mb-2">Free Quote</p>
              <p className="font-alatsi text-xl text-navy-deep">No Obligation</p>
            </div>
            <div>
              <p className="text-sm text-slate-500 uppercase tracking-wide mb-2">Coverage</p>
              <p className="font-alatsi text-xl text-navy-deep">Entire UK</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GetInTouchPage;
